import { FeatureFlag } from '@core/enums';
import { FieldDef } from '@core/models';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { Operator } from 'tsui';

export function getLinkedField(store: Store, mainObjectName: string, recordObjectName: string): FieldDef {
  return store
    .selectSnapshot(
      ObjectsManagerState.getFieldsByObjectName(mainObjectName, {
        allowedFieldsOnly: true,
        addNestedFields: false,
      }),
    )
    .find((x) => x.name.startsWith('cf_linked_') && x.type === 'record' && x.meta.record_type === recordObjectName);
}

export function getFjson(field: string, operator: Operator, value: any, nestedFiltersOn: boolean): string {
  if (!nestedFiltersOn) {
    return `[["${field}", "${operator}", [[${Number(value)}]]]]`;
  }

  return `[["${field}", "${operator}", "${value}"]]`;
}

export function getLinkedFieldAsFjson(
  store: Store,
  mainObjectName: string,
  recordObjectName: string,
  relatedToId: number,
): [string, string, any] {
  const nestedFiltersOn = store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NESTED_FILTERS));
  const linkedField = getLinkedField(store, mainObjectName, recordObjectName);
  const fieldReference = nestedFiltersOn ? `${linkedField.name}.id` : linkedField.name;
  const fjson = getFjson(fieldReference, 'in', relatedToId, nestedFiltersOn);
  return JSON.parse(fjson);
}
